















import { Prop, Component, Vue } from "vue-property-decorator";
import { acceptProjectInvitation } from "@/api/invitation-api";
import ReceiveInvitation from "./ReceiveInvitation.vue";

@Component({
  components: {
    ReceiveInvitation
  }
})
export default class ReceiveServiceInvitation extends Vue {
  @Prop({ required: true }) inviteCode!: string;

  accepted = false;
  errors: string[] = [];

  async accept() {
    try {
      await acceptProjectInvitation(this.inviteCode);
      this.accepted = true;
    } catch (e) {
      this.errors = e;
    }
  }
}
